/**
 * on dom ready
 */
import {Utils} from "./Utils";

Utils.executeWhenDocumentIsReady( () => {
    const contactCards = document.querySelectorAll(
        ".c-contactperson__container-smallcard",
    )

    contactCards.forEach((contactCard) => {
        contactCard.addEventListener("click", () => {
            const contactData = contactCard.querySelector(
                ".c-contactperson-contact__contact-data",
            )
            if (contactData) {
                contactData.classList.toggle(
                    "c-contactperson-contact__contact-data-visible",
                )
            }
        })
    })
})
